import {Injectable} from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  UrlTree,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {Observable} from 'rxjs';

import {UsermgmtService} from 'src/app/services/usermgmt.service';
import {AuthenticationService} from 'src/app/services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AccessGuard implements CanActivate {

  constructor(private userService: UsermgmtService,
              private router: Router,
              private authService: AuthenticationService) { }

  /* Check if a user is allowed to navigate to a specific route
     based on the set flag in the router
     If he is not allowed redirect him to an allowed url */
  canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot):
        Observable<boolean | UrlTree> |
        Promise<boolean | UrlTree> | boolean | UrlTree {

    const requiresLogin = next.data.requiresLogin || false;
    const requiredRole = next.data.requiredRole;
    const redirectIfLoggedIn = next.data.redirectIfLoggedIn || false;
    /* If the requiresLogin flag is set,
       the user has to be authenticated
       to navigate to the specified route
       Otherwise just redirect him to the login page */

    // redirect user to login page if he is not logged in
    if (requiresLogin) {
      if (!this.authService.isLoggedIn()) {
        // Always redirect to login if not authenticated, regardless of URL
        this.router.navigate(['/login'], {queryParams: {next: state.url}});
        return false;
      } else {
        // User has a token, validate it with the server
        return new Observable(observer => {
          this.authService.validateToken().subscribe(
            (isValid) => {
              if (isValid) {
                observer.next(true);
                observer.complete();
              } else {
                // Token is invalid, redirect to login
                this.router.navigate(['/login'], {queryParams: {next: state.url}});
                observer.next(false);
                observer.complete();
              }
            },
            () => {
              // Error occurred during validation, redirect to login
              this.router.navigate(['/login'], {queryParams: {next: state.url}});
              observer.next(false);
              observer.complete();
            }
          );
        });
      }
    }
    
    // Only allow access to the route if the user is publisher
    if (requiredRole === 'publisher') {
      if (!this.userService.getIsPublisher()) {
        this.router.navigate(['/tabs/speak']);
        return false;
      }
    }
    
    /* If the redirectIfLoggedIn flag is set,
       the user is redirected to the speak tab
       if he is already authenticated */
    if (redirectIfLoggedIn) {
      if (this.authService.isLoggedIn()) {
        this.router.navigate(['/tabs/speak']);
        return false;
      }
    }
    
    return true;
  }

}
